import { FC } from "react";
import MainNav1 from "./MainNav1";

export interface HeaderProps {
  navType?: "MainNav1" | "MainNav2";
  className?: string;
}

const Header: FC<HeaderProps> = ({ navType = "MainNav1", className = "" }) => {
  const renderNav = () => {
    switch (navType) {
      case "MainNav1":
        return <MainNav1 />;
      default:
        return <MainNav1 />;
    }
  };

  return (
    <div
      className={`nc-Header lg:bg-white bg-transparent rounded-full sticky top-0 w-full left-0 right-0 z-10 nc-header-bg bg-white max-w-6xl mx-auto ${className}`}
    >
      {renderNav()}
    </div>
  );
};

export default Header;
